import { render } from "./App.vue?vue&type=template&id=090397de"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=090397de&lang=scss"

import exportComponent from "/Users/zuzhiming/xlc-work/xlc-kuihuaguanwang/Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__